import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from './style';
import { RentersRentersInfoBreadcrumb } from "../RentersRentersInfo/CreateRentersRentersInfo/constant";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const RentersVehicleInquiry = (props) => {
  const classes = useStyles()
  const {
    fetchRentersVehicleInquirys,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportRentersVehicleInquiry,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateRentersVehicleInquiry,
    editRentersVehicleInquiryRoute,
    exportPDFRentersVehicleInquiry,
    exportCSVRentersVehicleInquiry
  } = props;

const [isCopy, setIsCopy] = useState(false)
const [isPrintError, setIsPrintError] = useState(false);

  const convertToTSV = (data) => {
    // Get headers from columns (including ID)
    const headers = data.columns.map((item) => item.colLabel).join("\t");

    // Get rows with values in the same order as columns
    const rows = data.rows
      .map((row) => {
        return data.columns
          .map((col) => {
            const value = row[col.dataKey];
            // Handle null/undefined values
            if (value === null || value === undefined) {
              return "-";
            }
            // Convert to string
            return String(value);
          })
          .join("\t");
      })
      .join("\n");

    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard.writeText(csv)
      .then(() => 
        setIsCopy(true)
      )
      .catch(err => {
        console.error("Copy failed:", err);
        setIsCopy(false);
      });
  };
  useEffect(() => {
    setTimeout(() =>     setIsCopy(false)
    , 1000);
  }, [isCopy]);
  
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  
  const handlePrint = () => {
    const success = printTableData({
      title: "Vehicle Inquiry",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
    });
    if (!success) {
      setIsPrintError(true);
    }
  };
  const renderPageHeaderSection = () => {
    return (
    

<div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Vehicle Inquiry</h4>
          </div>
          <div className="buttonarea">
            {/* <Button
             label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
             icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
             className={`p-button-text p-button-secondary`}
             onClick={() => {
               toggleFilterState(!areFiltersVisible);
             }}
           /> */}
          <Button
              label={"Copy"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={copyToClipboard}
            />
            <Button
              label={"Excel"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={exportRentersVehicleInquiry}
            />
             <Button
              label={"CSV"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={exportCSVRentersVehicleInquiry}
            />
            <Button
              label={"PDF"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={exportPDFRentersVehicleInquiry}
            />
            <Button
              label={"Print"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={handlePrint}
            />
            {
              screenPermissions?.create && (
            <Button
              label={"Create Vehicle Inquiry"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px", }}
              onClick={handleCreateRentersVehicleInquiry}
            />
              )
            }
        </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const filters = {
    global: { value: null },
  };

  const getToastProps = () => {
  
    let toastTitle = ""
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (
      isCopy
    ) {
      let toastTitle = "Data copied to clipboard!";
      if(!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      } 

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Vehicle Inquiry found.",
    filters,
    loadLazyData: fetchRentersVehicleInquirys,
    loading: isLoading,
    showMoreActions: false,
    sortField: null,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editRentersVehicleInquiryRoute,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: false,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
      <Breadcrumb list={RentersRentersInfoBreadcrumb } />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Vehicle Inquiry records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default RentersVehicleInquiry;

